<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :filters="filters"
                :service-path="servicePath"
                :go-to-details-on-row-click="false"
                :columns="columns"
                operations="refresh"
                ref="table">
      <template v-slot:job="{row}">
          <router-link v-if="row.job" @click.native.stop="" :to="`/jobs/${row.job.uuid}/dashboard#today`" class="text-capitalize font-weight-bold">
            {{row.job.title}}
          </router-link>
      </template>
      <template v-slot:given_name="{row}">
        {{row.given_name}} {{row.family_name}}
      </template>
      <template v-slot:status="{row}">
        <status-badge :status="row.status"/>
      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:file_cv="{row}">
        <tooltip-icon-button type="primary"
                             v-if="row.file_cv"
                             :content="$t('generic.download')"
                             icon="nc-icon nc-cloud-download-93"
                             @click.stop="downloadCV(row)">
        </tooltip-icon-button>
        <div v-else>
          {{$t('generic.na')}}
        </div>
      </template>
      <template v-slot:file_motivation="{row}">
        <tooltip-icon-button type="primary"
                             v-if="row.file_motivation"
                             :content="$t('generic.download')"
                             icon="nc-icon nc-cloud-download-93"
                             @click.stop="downloadMotivation(row)">
        </tooltip-icon-button>
        <div v-else>
          {{$t('generic.na')}}
        </div>
      </template>
      <template v-slot:extra-buttons="{row}">
        <template v-if="showCheckButtons(row)">
          <tooltip-icon-button type="success"
                               :content="$t('generic.approve')"
                               icon="nc-icon nc-check-2"
                               @click.stop="approveApplicant(row)">
          </tooltip-icon-button>
          <tooltip-icon-button type="danger"
                               :content="$t('generic.reject')"
                               icon="nc-icon nc-simple-remove"
                               @click.stop="rejectApplicant(row)">
          </tooltip-icon-button>
        </template>
        <base-button type="default"
                     size="sm"
                     outline
                     :loading="row.resendLoading"
                     @click.stop="resendApplication(row)">
          {{$t('generic.resend')}}
        </base-button>
      </template>
    </data-table>
  </div>
</template>
<script>
  import entities from 'src/config/entities'
  import JobService from 'src/services/JobService'
  import FileService from 'src/services/FileService'
  import ApplicantsService from 'src/services/ApplicantsService'
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'
  import TextOverflowTooltip from 'src/components/TextOverflowTooltip'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'applicant-list',
    props: {
      jobId: String,
      filters: {
        type: Array,
        default: () => [
          {
            key: 'with',
            value: 'job'
          },
          {
            key: 'sort',
            value: '+created_at'
          }
        ]
      }
    },
    components: {
      TooltipIconButton,
      TextOverflowTooltip
    },
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        entity: entities.APPLICANTS
      }
    },
    computed: {
      service () {
        if (this.jobId) {
          return JobService
        }
        return ApplicantsService
      },
      columns () {
        return [
          {
            prop: 'job',
            label: this.$t('job.details.applicants.job.name'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'given_name',
            label: this.$t('job.details.applicants.name'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'email',
            label: this.$t('generic.email'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'phone',
            label: this.$t('generic.phone'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'status',
            label: this.$t('generic.status'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'file_cv',
            label: this.$t('job.details.applicants.file_cv'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'file_motivation',
            label: this.$t('job.details.applicants.file_motivation'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('job.details.applicants.date'),
            minWidth: '180px',
            sortable: true
          }
        ]
      },
      servicePath () {
        if (this.jobId) {
          return `${this.$route.params.id}/applicants`
        }
        return undefined
      }
    },
    methods: {
      showCheckButtons (row) {
        return row.status !== 'new' && row.status !== 'rejected'
      },
      async approveApplicant (row) {
        let newStatus = 'new'
        await ApplicantsService.verify(row.uuid, {
          status: newStatus
        })
        row.status = newStatus
      },
      async rejectApplicant (row) {
        let newStatus = 'rejected'
        await ApplicantsService.verify(row.uuid, {
          status: newStatus
        })
        row.status = newStatus
      },
      async resendApplication (row) {
        try {
          this.$set(row, 'resendLoading', true)
          await ApplicantsService.resend(row.uuid, {
            status: row.status,
            favourite: row.favorite
          })
          this.$notify({
            type: 'success',
            message: this.$t('job.details.applicants.resendMessage')
          })
        } finally {
          this.$set(row, 'resendLoading', false)
        }
      },
      async downloadCV (row) {
        let name = `CV-${row.email}`
        this.$set(row, 'loading', true)
        await FileService.downloadFile(row.file_cv, name)
      },
      async downloadMotivation (row) {
        let name = `Motivation-${row.email}`
        await FileService.downloadFile(row.file_motivation, name)
      }
    }
  }
</script>
<style>
</style>
